var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reviews" }, [
    _vm.showHeader
      ? _c(
          "div",
          {
            staticClass:
              "lg:mb-60 md:flex-row md:items-center lg:pb-24 flex flex-col items-start justify-between pb-32 mb-32 border-b border-gray-300"
          },
          [
            _c(
              "div",
              { staticClass: "md:mb-0 flex flex-col mb-24" },
              [
                _c("h2", { staticClass: "h4 lg:mb-8 mb-24" }, [
                  _vm._v("Reviews")
                ]),
                _vm._v(" "),
                _c("score-stars", {
                  staticClass: "lg:mb-16 mb-8",
                  attrs: { score: _vm.averageScore, large: true }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.averageScore +
                        " sterren op basis van " +
                        _vm.reviews.length +
                        " reviews"
                    )
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-green",
                on: { click: _vm.toggleSlideout }
              },
              [_vm._v(_vm._s(_vm.translations.write_a_review))]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "lg:-mb-60 -mb-32" },
      [
        _c(
          "transition-group",
          {
            staticClass: "row gutter-60",
            attrs: { name: "component-fade", mode: "out-in", tag: "div" }
          },
          _vm._l(_vm.loadedReviews, function(review) {
            return _c(
              "div",
              {
                key: review.date,
                staticClass: "lg:mb-60 mb-32",
                class: _vm.columnClass
              },
              [
                _c(
                  "div",
                  { staticClass: "review flex flex-col items-start" },
                  [
                    _c("p", {
                      staticClass: "text-20 font-bold text-gray-800",
                      domProps: { innerHTML: _vm._s(review.title) }
                    }),
                    _vm._v(" "),
                    _c("time", {
                      staticClass: "text-14 text-blue opacity-70 mb-8",
                      attrs: { datetime: review.date },
                      domProps: {
                        innerHTML: _vm._s(_vm.formattedDate(review.date))
                      }
                    }),
                    _vm._v(" "),
                    _c("score-stars", {
                      staticClass: "mb-16",
                      attrs: { score: review.score }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "text-black",
                      domProps: { innerHTML: _vm._s(review.text) }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.canLoadMore
      ? _c("div", { staticClass: "flex justify-center mt-40" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-blue",
              on: { click: _vm.loadMore }
            },
            [_vm._v(_vm._s(_vm.translations.show_more))]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showHeader
      ? _c(
          "div",
          {
            staticClass: "slideout-container",
            class: { active: _vm.slideoutIsOpen },
            on: { click: _vm.toggleSlideout }
          },
          [
            _c(
              "div",
              {
                staticClass: "slideout",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "close",
                  on: { click: _vm.toggleSlideout }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "slideout-content" }, [
                  _c(
                    "div",
                    { staticClass: "md:py-80 md:px-40 px-20 py-56" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "button-class":
                              "btn btn-green btn-rounded w-full font-bold",
                            "submit-text": "Review plaatsen"
                          }
                        },
                        [
                          _c("h2", { staticClass: "h5 mb-16" }, [
                            _vm._v(_vm._s(_vm.translations.write_a_review))
                          ]),
                          _vm._v(" "),
                          _c("score-stars", {
                            staticClass: "md:mb-40 mb-24",
                            attrs: { score: 5, large: true, input: true },
                            on: { "score-stars-input": _vm.setScore }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "mb-16",
                            attrs: {
                              rules: "required",
                              label: _vm.translations.title_label
                            },
                            model: {
                              value: _vm.newReview.title,
                              callback: function($$v) {
                                _vm.$set(_vm.newReview, "title", $$v)
                              },
                              expression: "newReview.title"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "mb-16",
                            attrs: {
                              rules: "required",
                              label: _vm.translations.description,
                              type: "textarea"
                            },
                            model: {
                              value: _vm.newReview.text,
                              callback: function($$v) {
                                _vm.$set(_vm.newReview, "text", $$v)
                              },
                              expression: "newReview.text"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }